import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import MEListTable from './MEListTable'
import { Box } from '@chakra-ui/react';

const MEList = () => {
    return (
        <div>
            <HeaderSection
                title="Voucher Multi Entry"
                breadcrumb={["Dashboard", "Voucher"]}
            />
            <Box p={6}>

                <MEListTable />
            </Box>
        </div>
    )
}

export default MEList